import { Paper, ScrollArea, Spoiler, Text } from '@mantine/core'
import withErrorBoundaryAndPolicyCheck from '@v2/commons/HOC/ErrorBoundaryAndPolicyCheckHOC'
import { POLICIES } from '@v2/commons/config'
import dayjs from 'dayjs'

import { Icons } from 'src/common/components'

import { IMessage } from '../../types/chat.types'
import styles from './chat-message-list.module.scss'

interface ChatMessageListProps {
  messages: IMessage[]
}

const ChatList = ({ messages }: ChatMessageListProps) => {
  const getFormattedDate = (date: string) => {
    return dayjs.utc(date).local().format('MMM D, YYYY, hh:mm A')
  }

  return (
    <ScrollArea.Autosize
      type="scroll"
      scrollbars="y"
      mah={341}
      mt={32}
      offsetScrollbars={true}
    >
      {messages.map(({ createdAt, message, user, id }) => (
        <Paper
          key={id}
          classNames={{
            root: styles['chat-message-list-item'],
          }}
        >
          <Text className={styles['created-label']}>
            {getFormattedDate(createdAt)}
          </Text>
          <Spoiler
            maxHeight={90}
            pt={24}
            pr={24}
            pl={24}
            showLabel={<Icons.ArrowExpand />}
            hideLabel={
              <Icons.ArrowExpand
                className={styles['arrow-expand-icon']}
                style={{ transform: 'rotate(180deg)' }}
              />
            }
            key={id}
            classNames={{
              root: styles['toggle-show-root'],
              control: styles['toggle-show-control'],
              content: styles['toggle-show-content'],
            }}
          >
            <Text fz={16} fw={700} c={'#21252C'}>
              {user?.firstName + '' + user?.lastName}
            </Text>
            <Text
              w={'100%'}
              component="div"
              className={styles['text-content']}
              dangerouslySetInnerHTML={{
                __html: message,
              }}
              mb={16}
            />
          </Spoiler>
        </Paper>
      ))}
    </ScrollArea.Autosize>
  )
}
export default withErrorBoundaryAndPolicyCheck(
  ChatList,
  POLICIES.isGetChatMessagesEnabled,
)
